function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "LanguageNavCZ",
  transform: "translate(-1185.45 -368.27)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M1197.45 381.141l-8.163 8.1a11.488 11.488 0 010-16.19z",
  transform: "translate(0 -.871)",
  fill: "#304ffe"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M1209.8 383.21a11.5 11.5 0 01-19.663 8.1l8.163-8.1z",
  transform: "translate(-.853 -2.94)",
  fill: "#ef5350"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M1209.8 380.27h-11.5l-8.163-8.091a11.494 11.494 0 0119.663 8.091z",
  transform: "translate(-.853)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_33",
  "data-name": "Path 33",
  d: "M1197.45 368.77a11.5 11.5 0 11-11.5 11.5 11.5 11.5 0 0111.5-11.5z",
  fill: "none",
  stroke: "#0f426e",
  strokeWidth: 1
}));

function SvgLangCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangCs);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8ZyBpZD0iTGFuZ3VhZ2VOYXZDWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExODUuNDUgLTM2OC4yNykiPgogICAgPHBhdGggaWQ9IlBhdGhfMzAiIGRhdGEtbmFtZT0iUGF0aCAzMCIgZD0iTTExOTcuNDUsMzgxLjE0MWwtOC4xNjMsOC4xYTExLjQ4OCwxMS40ODgsMCwwLDEsMC0xNi4xOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTAuODcxKSIgZmlsbD0iIzMwNGZmZSIvPgogICAgPHBhdGggaWQ9IlBhdGhfMzEiIGRhdGEtbmFtZT0iUGF0aCAzMSIgZD0iTTEyMDkuOCwzODMuMjFhMTEuNSwxMS41LDAsMCwxLTE5LjY2Myw4LjFsOC4xNjMtOC4xWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuODUzIC0yLjk0KSIgZmlsbD0iI2VmNTM1MCIvPgogICAgPHBhdGggaWQ9IlBhdGhfMzIiIGRhdGEtbmFtZT0iUGF0aCAzMiIgZD0iTTEyMDkuOCwzODAuMjdoLTExLjVsLTguMTYzLTguMDkxYTExLjQ5NCwxMS40OTQsMCwwLDEsMTkuNjYzLDguMDkxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuODUzIDApIiBmaWxsPSIjZjJmMmYyIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8zMyIgZGF0YS1uYW1lPSJQYXRoIDMzIiBkPSJNMTEuNSwwQTExLjUsMTEuNSwwLDEsMSwwLDExLjUsMTEuNSwxMS41LDAsMCwxLDExLjUsMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExODUuOTUgMzY4Ljc3KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMGY0MjZlIiBzdHJva2Utd2lkdGg9IjEiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };